var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-building-bg-violet';
                    var viewUrl = 'sprite.svg#view-icon-building-bg-violet';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 49 50',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };